export default {
  item:
    '{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})',
  defaultOption: 'See all',
};
